const messages = {
  download: { id: 'admin/promotions.utils.download' },
}

export default messages
